import React, { useEffect, useState } from "react";
import InternalServerError from "../components/InternalServerError";
import UnauthorizedAccess from "../components/UnauthorizedAccess";
import RasporedDataTable from "../components/RasporedDataTable";

export const Raspored = (props) => {
  const [restData, setRestData] = useState([]);
  const [fetchState, setFetchState] = useState(null);

  useEffect(() => {
    fetch(
      props.rest +
        sessionStorage.getItem("ustanova") +
        "&prema_obliku=" +
        sessionStorage.getItem("premaObliku") +
        "&godina_upisa=" +
        sessionStorage.getItem("godinaUpisa") +
        "&redni_broj=" +
        sessionStorage.getItem("redniBroj") +
        "&razred=" +
        sessionStorage.getItem("razredPregleda"),
      {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Authorization: sessionStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then((response) => {
        //console.log("Response izostanci: " + response);
        if (response.status === 200) {
          setFetchState(200);
          return response.json();
        } else if (response.status === 204) {
          setFetchState(204);
          return null;
        } else if (response.status === 401) {
          setFetchState(401);
          return null;
        } else if (response.status === 500) {
          setFetchState(500);
          return null;
        } else {
          return null;
        }
      })
      .then((data) => {
        data.forEach( aktivnost => {
          if (aktivnost.status !== true && aktivnost.pocetak >= new Date().toJSON()) {
            setRestData(restData => [...restData, aktivnost]);
          } 
        })
        //console.log("Data stringify test:" + JSON.stringify(data));
        //setRestData(data);
      })
      .catch((err) => {
        //console.log("Error izostanci:" + err);
      });
  }, [props.rest]);


  return (
    <div>
      <p className="page-title">Raspored predavanja za {sessionStorage.getItem("razredPregleda")}. razred</p>
      <div>
        {fetchState === 200 ? <RasporedDataTable data={restData} /> : ""}
        {fetchState === 401 ? <UnauthorizedAccess /> : ""}
        {fetchState === 500 ? <InternalServerError /> : ""}
      </div>
    </div>
  );
};

export default Raspored;
